import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Grid } from '@/components/Grid';

export const FlexWrapper = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    &::-webkit-scrollbar {
      display: none;
    }
    ${theme.media.md.up} {
    }
  `}
  & > :first-child {
    padding-left: 0;
  }
  & > :last-child {
    padding-right: 0;
  }
`;

export const FlexItem = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 1;
    padding: 0 6px;
    min-width: 358px;
    width: 47%;
    ${theme.media.md.up} {
      display: none;
    }
  `}
  & > :first-child {
    height: 100%;
  }
`;

export const GridWrapper = styled(Grid)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 12px;
      display: grid;
    }
  `}
`;

export const GridItem = styled(Box)`
  ${({ theme }) => css`
    display: none;
    ${theme.media.md.up} {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }
  `}
`;
